"use client";
import EventInbound from "@/components/Events/EventInbound";

export default function EventInboundPage() {
  return <EventInbound />;
}
